import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalSearchService } from '../global-search.service';

@Component({
  selector: 'app-global-search-history',
  templateUrl: './global-search-history.component.html',
  styleUrls: ['./global-search-history.component.css'],
})
export class GlobalSearchHistoryComponent {
  history: any[] = [];
  @Output() itemClicked = new EventEmitter<void>();

  constructor(
    private globalSearchService: GlobalSearchService,
    private router: Router
  ) {
    this.history = this.globalSearchService.getHistory();
  }

  handleClick(item: any) {
    if (item.type === 'contact') {
      this.router.navigate([`/dashboard/contact/${item.id}/view`]);
    } else if (item.type === 'product') {
      this.router.navigate([`/dashboard/product/${item.id}`]);
    } else if (item.type === 'action' && item.link) {
      this.router.navigate([item.link]);
    }
    this.itemClicked.emit();
  }

  clearHistory() {
    this.globalSearchService.clearHistory();
    this.history = [];
  }
}
